import "./App.css";
import { Toaster } from "react-hot-toast";
import { UserCapabilityProvider } from "./components/ConstantReducerProvider";
import RootRouter from "./connector/RootRouter";

function App() {
  return (
    <div>
      <UserCapabilityProvider>
        <Toaster position="top-center" reverseOrder={true} />
        <RootRouter />
      </UserCapabilityProvider>
    </div>
  );
}

export default App;
